document.addEventListener("cart:updated", function(event) {
  let total_cart = event.detail["cart"]["total_price"] / 100
  let threshold = document.querySelector('free-shipping-bar').getAttribute('threshold') / 100
  let free_shipping_bar = document.querySelector('free-shipping-bar')

  free_shipping_bar.style.setProperty(
      "--progress",
      Math.min(
          parseFloat(total_cart / threshold),
          1
      )
  );
});

document.addEventListener("ajaxProduct:added", function(event) {
  if (event.detail.product.items[0]) {
    let cart_subtotal = parseFloat(document.querySelector('.cart__items').getAttribute('data-cart-subtotal'))
    const new_total = (cart_subtotal + parseFloat(event.detail.product.items[0].line_price)) / 100
    let threshold = document.querySelector('free-shipping-bar').getAttribute('threshold') / 100
    let free_shipping_bar = document.querySelector('free-shipping-bar')
  
    free_shipping_bar.style.setProperty(
        "--progress",
        Math.min(
            parseFloat(new_total / threshold),
            1
        )
    );
  }
});

